import { fieldError } from '../fieldError';

export function checkMax(maxValue) {
  return value =>
    value > maxValue ? fieldError(`O valor máximo é ${maxValue}`) : null;
}
